import { lazyLoad } from "../../../utils/loadable";

export const AdminSettingCatalogPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
);
